import {
  Box,
  Dialog,
  DialogContent,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import CancelScheduleSendOutlinedIcon from "@mui/icons-material/CancelScheduleSendOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CustomButton from "../CommonComponents/CustomButton";
import { useEffect, useState } from "react";
import CustomLabel from "../CommonComponents/CustomLabel";
import CustomCheckbox from "../CommonComponents/CustomCheckbox";
import { useSelector } from "react-redux";
import {
  addReportScheduler,
  deleteReportScheduler,
  disableReportScheduler,
  enableReportScheduler,
  getDevicesReportGen,
  getEntireTemplateTree,
  getSavedReportScheduler,
  getUserGroupReports,
} from "../../Restclient/datacollection";
import CustomToast from "../CommonComponents/CustomToast";
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import CustomTreeSelect from "../CommonComponents/CustomTreeSelect";
import CustomMultiselectWithCheckbox from "../CommonComponents/CustomMultiselectWithCheckbox";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomDatePicker from "../CommonComponents/CustomDatePicker";
import dayjs from "dayjs";

export default function Scheduler() {
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const theme = useSelector((state) => state.themedata.theme);

  const currentDate = dayjs();

  const [update, setUpdate] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [table_rows, setTable_rows] = useState([]);
  const [checkedArray, setCheckedArray] = useState([]);
  const [allChecked, setAllChecked] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [popup, setPopup] = useState(false);
  const [schedulerName, setSchedulerName] = useState("");
  const [groupTree, setGroupTree] = useState([]);
  const [selectedGroupVal, setSelectedGroupVal] = useState("");
  const [deviceList, setDeviceList] = useState([]);
  const [deviceListID, setDeviceListID] = useState([]);
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [dynamicTemp, setDynamicTemp] = useState(false);
  const [frequency, setFrequency] = useState("Hourly");
  const [selectedStartDT, setSelectedStartDT] = useState(dayjs(new Date()));
  const [selectedEndDT, setSelectedEndDT] = useState(
    currentDate.add(1, "hour"),
  );
  const [selectedGenDT, setSelectedGenDT] = useState(
    currentDate.add(2, "hour"),
  );
  const [enableEmail, setEnableEmail] = useState(false);
  const [exportType, setExportType] = useState("PDF");
  const [userOptions, setUserOptions] = useState([]);
  const [userOptionsID, setUserOptionsID] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [enableScheduler, setEnableScheduler] = useState(false);

  const table_head = [
    <CustomCheckbox
      onChange={(value) => setAllChecked(value)}
      checked={allChecked}
    />,
    "Scheduler Name",
    "Template",
    "Frequency",
    "Start Date Time",
    "End Date Time",
    "Generation Date Time",
    "State",
  ];

  const getSelectedDeviceIDs = (selectedDevices) => {
    return selectedDevices.map((deviceName) => {
      const index = deviceList.indexOf(deviceName);
      return deviceListID[index];
    });
  };

  const getSelectedUserIDs = (selectedUsers) => {
    return selectedUsers.map((userName) => {
      const index = userOptions.indexOf(userName);
      return userOptionsID[index];
    });
  };

  const handleClosePopup = (event, reason) => {
    if (reason === "closeButton") {
      setPopup(false);
      setSchedulerName("");
      setSelectedGroupVal("");
      setDynamicTemp(false);
      setSelectedDevices([]);
      setSelectedUsers([]);
      setFrequency("Hourly");
      setSelectedStartDT(dayjs(new Date()));
      setEnableEmail(false);
      setExportType("PDF");
      setSelectedUsers([]);
      setEnableScheduler(false);
      // setEdit(0);
      // setEditIndex(-1);
    }
  };

  const handleCheckboxClick = (index) => {
    if (checkedArray.includes(index)) {
      const updatedArray = checkedArray.filter((item) => item !== index);
      setCheckedArray(updatedArray);
    } else {
      setCheckedArray([...checkedArray, index]);
    }
  };

  const handleEnableMultipleScheduler = () => {
    setLoading(true);
    enableReportScheduler(
      checkedArray.map((index) => table_rows[index][7]),
      (res) => {
        if (res.data === 1) {
          setUpdate(11);
        } else if (res.data === 0) {
          setUpdate(10);
        }
      },
    );
  };

  const handleDisableMultipleScheduler = () => {
    setLoading(true);
    disableReportScheduler(
      checkedArray.map((index) => table_rows[index][7]),
      (res) => {
        if (res.data === 1) {
          setUpdate(21);
        } else if (res.data === 0) {
          setUpdate(20);
        }
      },
    );
  };

  const handleSave = () => {
    if (
      schedulerName === "" ||
      selectedUsers.length === 0 ||
      (dynamicTemp && selectedDevices.length === 0)
    ) {
      setUpdate(3);
      return;
    }

    addReportScheduler(
      schedulerName,
      selectedGroupVal.split("/")[0],
      selectedDevices.length > 0 ? getSelectedDeviceIDs(selectedDevices) : [],
      frequency,
      Math.floor(selectedStartDT.valueOf() / 1000),
      Math.floor(selectedEndDT.valueOf() / 1000),
      Math.floor(selectedGenDT.valueOf() / 1000),
      enableEmail,
      exportType,
      selectedUsers.length > 0 ? getSelectedUserIDs(selectedUsers) : [],
      enableScheduler,
      (res) => {
        setUpdate(res.data);
        if (res.data === 2) {
          return;
        }
        setSchedulerName("");
        setSelectedGroupVal("");
        setDynamicTemp(false);
        setSelectedDevices([]);
        setSelectedUsers([]);
        setFrequency("Hourly");
        setSelectedStartDT(dayjs(new Date()));
        setEnableEmail(false);
        setExportType("PDF");
        setSelectedUsers([]);
        setEnableScheduler(false);
        // setEdit(0);
        // setEditIndex(-1);
        setPopup(false);
      },
    );
  };

  useEffect(() => {
    let newEndDT;

    if (frequency === "Hourly") {
      newEndDT = selectedStartDT.add(1, "hour");
    } else if (frequency === "Daily") {
      newEndDT = selectedStartDT.add(1, "day");
    } else if (frequency === "Weekly") {
      newEndDT = selectedStartDT.add(1, "week");
    } else if (frequency === "Monthly") {
      newEndDT = selectedStartDT.add(1, "month");
    }

    setSelectedEndDT(newEndDT);
    setSelectedGenDT(newEndDT.add(1, "hour"));
  }, [selectedStartDT, frequency]);

  useEffect(() => {
    getDevicesReportGen(selectedGroupVal.split("/")[0], (res) => {
      setDeviceList(res.data.devices.map((device) => device.Name));
      setDeviceListID(res.data.devices.map((device) => device.DeviceID));
      setDynamicTemp(res.data.dynamic);
    });
    setSelectedDevices([]);
  }, [selectedGroupVal]);

  useEffect(() => {
    if (allChecked) {
      const length = table_rows.length;
      const indicesArray = Array.from({ length }, (_, index) => index);
      setCheckedArray(indicesArray);
    } else {
      setCheckedArray([]);
    }
  }, [allChecked]);

  useEffect(() => {
    if (checkedArray.length === table_rows.length && table_rows.length !== 0) {
      setAllChecked(true);
    } else {
      const temp = [...checkedArray];
      setAllChecked(false);
      setCheckedArray(temp);
    }
  }, [checkedArray]);

  useEffect(() => {
    getSavedReportScheduler((res) => setTable_rows(res.data.result));
    getEntireTemplateTree((res) => setGroupTree(res.data));
    getUserGroupReports((res) => {
      setUserOptions(res.data.names);
      setUserOptionsID(res.data.ids);
    });
  }, [projectId]);

  useEffect(() => {
    setCheckedArray([]);
    setAllChecked(false);
    if (
      update === 1 ||
      update === 11 ||
      update === 21 ||
      update === 31 ||
      update === 41
    ) {
      getSavedReportScheduler((res) => setTable_rows(res.data.result));
    }
    setLoading(false);
    const timer = setTimeout(() => {
      setUpdate(-1);
    }, 3000);
    return () => clearTimeout(timer);
  }, [update]);

  return (
    <div
      style={{ height: "100%", boxSizing: "border-box" }}
      className="compliance-config"
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "right",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <CustomActionButton
              onClick={handleEnableMultipleScheduler}
              disabled={
                checkedArray.length === 0 || loading === true ? true : false
              }
              buttonText={
                <Tooltip title="Enable Scheduler">
                  <ScheduleSendOutlinedIcon width={"22px"} height={"22px"} />
                </Tooltip>
              }
            />
            <CustomActionButton
              onClick={handleDisableMultipleScheduler}
              disabled={
                checkedArray.length === 0 || loading === true ? true : false
              }
              buttonText={
                <Tooltip title="Disable Scheduler">
                  <CancelScheduleSendOutlinedIcon
                    width={"22px"}
                    height={"22px"}
                  />
                </Tooltip>
              }
            />
            <CustomActionButton
              onClick={() => setOpenDeleteDialog(true)}
              disabled={
                checkedArray.length === 0 || loading === true ? true : false
              }
              buttonText={
                <Tooltip title="Delete">
                  {" "}
                  <DeleteOutlineOutlinedIcon width={"22px"} height={"22px"} />
                </Tooltip>
              }
            />
            <CustomButton
              disabled={checkedArray.length > 0 ? true : false}
              buttonText={"Add"}
              onClick={() => {
                setPopup(true);
              }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            {update === 1 ? (
              <CustomToast
                openToast={1}
                type={"Success"}
                autoHideDuration={10000}
                toastText={"Scheduler Creation Successfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 0 ? (
              <CustomToast
                openToast={1}
                type={"Error"}
                autoHideDuration={10000}
                toastText={"Scheduler Creation Unsuccessfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 4 ? (
              <CustomToast
                openToast={1}
                type={"Error"}
                autoHideDuration={10000}
                toastText={"Scheduler configuration already Exists!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 11 ? (
              <CustomToast
                openToast={1}
                type={"Success"}
                autoHideDuration={10000}
                toastText={"Scheduler Enable Successfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 10 ? (
              <CustomToast
                openToast={1}
                type={"Error"}
                autoHideDuration={10000}
                toastText={"Scheduler Enable Unsuccessfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 21 ? (
              <CustomToast
                openToast={1}
                type={"Success"}
                autoHideDuration={10000}
                toastText={"Scheduler Disable Successfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 20 ? (
              <CustomToast
                openToast={1}
                type={"Error"}
                autoHideDuration={10000}
                toastText={"Scheduler Disable Unsuccessfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 31 ? (
              <CustomToast
                openToast={1}
                type={"Success"}
                autoHideDuration={10000}
                toastText={"Scheduler Deletion Successfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 30 ? (
              <CustomToast
                openToast={1}
                type={"Error"}
                autoHideDuration={10000}
                toastText={"Scheduler Deletion Unsuccessfull!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 41 ? (
              <CustomToast
                openToast={1}
                type={"Success"}
                autoHideDuration={10000}
                toastText={"Scheduler Edited Successfully!"}
                onClose={() => setUpdate(-1)}
              />
            ) : update === 40 ? (
              <CustomToast
                openToast={1}
                type={"Error"}
                autoHideDuration={10000}
                toastText={"Scheduler could not be edited!"}
                onClose={() => setUpdate(-1)}
              />
            ) : (
              <></>
            )}
          </Box>
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            gap: "8px",
            padding: "8px",
            backgroundColor: "var(--PrimaryBackground)",
            boxSizing: "border-box",
            overflow: "auto",
          }}
        >
          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: "var(--secondary-backgroundLK)",
              padding: "0px 8px",
              borderRadius: 0,
            }}
            elevation={0}
          >
            <Table stickyHeader sx={{ width: "100%" }} size="small">
              <TableHead>
                <TableRow sx={{ border: "0px" }}>
                  {table_head.map((table_head_value, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        textAlign: "left",
                        fontSize: "12px",
                        fontWeight: 700,
                        color: "var(--grey-variation-tableLK)",
                        backgroundColor: "var(--secondary-backgroundLK)",
                      }}
                    >
                      {table_head_value}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {table_rows.map((row, rowIndex) => (
                  <TableRow
                    key={rowIndex}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      height: "9px",
                      "& > *": {
                        borderBottom: "1px solid var(--table-boarder-line)",
                      },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "var(--grey-variation-tablerowsLK)",
                      }}
                    >
                      <CustomCheckbox
                        onChange={() => handleCheckboxClick(rowIndex)}
                        checked={
                          checkedArray.includes(rowIndex) === true
                            ? true
                            : false
                        }
                      />
                    </TableCell>
                    {row.map((cell, cellIndex) => {
                      if (cellIndex < 7) {
                        return (
                          <TableCell
                            key={cellIndex}
                            component="th"
                            scope="row"
                            sx={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "var(--grey-variation-tablerowsLK)",
                            }}
                          >
                            {cell}
                          </TableCell>
                        );
                      }
                      return null;
                    })}

                    {/* <TableCell
                      component="th"
                      scope="row"
                      sx={{
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "var(--grey-variation-tablerowsLK)",
                      }}
                    >
                      <CustomActionButton
                        // onClick={() => {
                        //   setEdit(1);
                        //   setEditIndex(row[7]);
                        //   setPopup(true);
                        // }}
                        disabled={checkedArray.length > 1 ? true : false}
                        buttonText={"Edit"}
                      />
                    </TableCell> */}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
      <Dialog
        maxWidth={"l"}
        open={popup}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            event.preventDefault();
          } else {
            handleClosePopup(event, reason);
          }
        }}
        aria-labelledby="responsive-dialog-title"
        PaperProps={{
          style: {
            backgroundColor: theme === "dark" ? "#000000" : "#EFEFEF",
            boxShadow: "none",
            borderRadius: "0px",
          },
        }}
        BackdropProps={{
          style: {
            backgroundColor:
              theme === "dark" ? "rgba(255,255,255,0.7)" : "rgba(0,0,0,0.7)",
          },
        }}
      >
        <DialogContent>
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
                gap: "8px",
              }}
            >
              <div style={{ flexGrow: 1 }}> </div>
              <div style={{ width: "250px", height: "40px" }}>
                {update === 3 ? (
                  <CustomLabel
                    fontSize={"6px"}
                    labelText={`Fill all the required fields - ${
                      schedulerName === "" &&
                      selectedUsers.length === 0 &&
                      dynamicTemp &&
                      selectedDevices.length === 0
                        ? "Scheduler Name, User Groups, Devices"
                        : schedulerName === "" && selectedUsers.length === 0
                          ? "Scheduler Name, User Groups"
                          : schedulerName === "" &&
                              dynamicTemp &&
                              selectedDevices.length === 0
                            ? "Scheduler Name, Devices"
                            : selectedUsers.length === 0 &&
                                dynamicTemp &&
                                selectedDevices.length === 0
                              ? "User Groups, Devices"
                              : schedulerName === ""
                                ? "Scheduler Name"
                                : selectedUsers.length === 0
                                  ? "User Groups"
                                  : dynamicTemp && selectedDevices.length === 0
                                    ? "Devices"
                                    : null
                    }`}
                    color={"red"}
                  />
                ) : update === 2 ? (
                  <CustomLabel labelText={"Scheduler Name already exists!"} />
                ) : (
                  <></>
                )}
              </div>
              <CustomButton buttonText={"Save"} onClick={handleSave} />
              <CustomCancelButton
                buttonText={"Close"}
                onClick={(event) => handleClosePopup(event, "closeButton")}
              />
            </div>
            <div style={{ backgroundColor: "#FFFFFF" }}>
              <table
                width="100%"
                style={{
                  textAlign: "left",
                  padding: "16px 0px 16px 16px",
                  margin: "0px",
                }}
              >
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel
                      htmlFor={"new-scheduler-name"}
                      labelText={"Scheduler Name*"}
                    />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomTextField
                      id={"new-scheduler-name"}
                      width={227}
                      defaultValue={schedulerName}
                      onChange={(val) => setSchedulerName(val)}
                      permittedCharacters={"^[a-zA-Z0-9_]*$"}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Template*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomTreeSelect
                      options={groupTree}
                      value={selectedGroupVal}
                      onChange={(val) => {
                        setSelectedGroupVal(val);
                      }}
                      disabledItemValues={(item) => item.type === "group"}
                      placeholder=""
                      width="227px"
                      fontSize="16px"
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Devices*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomMultiselectWithCheckbox
                      options={deviceList}
                      selecteddata={selectedDevices}
                      disabled={dynamicTemp === false ? true : false}
                      onChange={(val) => setSelectedDevices([...val])}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Frequency*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomDropDown
                      options={["Hourly", "Daily", "Weekly", "Monthly"]}
                      onChange={(val) => setFrequency(val)}
                      width={227}
                      name={"generate-list"}
                      defaultValue={frequency}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Start Date Time*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomDatePicker
                      minDateTime={dayjs()}
                      name={"startDT"}
                      width={227}
                      onChange={(val) => setSelectedStartDT(val)}
                      defaultValue={selectedStartDT}
                      views={["day", "month", "year", "hours", "minutes"]}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"End Date Time*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomDatePicker
                      disabled={true}
                      name={"endDT"}
                      width={227}
                      onChange={(val) => setSelectedEndDT(val)}
                      defaultValue={selectedEndDT}
                      views={["day", "month", "year", "hours", "minutes"]}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Generation Date Time*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomDatePicker
                      minDateTime={selectedEndDT.add(1, "hour")}
                      name={"generationDT"}
                      width={227}
                      onChange={(val) => setSelectedGenDT(val)}
                      defaultValue={selectedGenDT}
                      views={["day", "month", "year", "hours", "minutes"]}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Email"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomCheckbox
                      onChange={(val) => setEnableEmail(val)}
                      checked={enableEmail}
                      defaultChecked={enableEmail}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Export Type*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomDropDown
                      options={["PDF"]}
                      onChange={(val) => setExportType(val)}
                      width={227}
                      name={"generate-list"}
                      defaultValue={exportType}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"User Groups*"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomMultiselectWithCheckbox
                      options={userOptions}
                      width={227}
                      onChange={(val) => setSelectedUsers(val)}
                      selecteddata={selectedUsers}
                    />
                  </td>
                </tr>
                <tr>
                  <td style={{ paddingBottom: "16px", paddingRight: "32px" }}>
                    <CustomLabel labelText={"Enable Scheduler"} />
                  </td>
                  <td style={{ paddingBottom: "16px" }}>
                    <CustomCheckbox
                      onChange={(val) => setEnableScheduler(val)}
                      checked={enableScheduler}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        </DialogContent>
      </Dialog>
      {
        <CustomDialogBox
          openDialog={openDeleteDialog}
          dialogTitle={"Delete"}
          dialogText={"Are you sure?"}
          confirmText={"Delete"}
          cancelText={"Cancel"}
          handleCloseDialog={() => setOpenDeleteDialog(false)}
          handleConfirmDialog={() => {
            deleteReportScheduler(
              checkedArray.map((index) => table_rows[index][7]),
              (res) => {
                setOpenDeleteDialog(false);
                if (res.data === 1) {
                  setUpdate(31);
                } else if (res.data === 0) {
                  setUpdate(30);
                }
                setLoading(true);
              },
            );
          }}
          type={"Info"}
        />
      }
    </div>
  );
}
